import axios from "@/config/axios";
// 学院申请总结分类
export const cate_list = type => axios.post("/index.php/Home/index/cate_list", {
  type
});

// 申请总结
export const article_list = data => axios.post("/index.php/Home/index/article_list", data);